export default __webpack_public_path__ + "static/media/none.0cbabb11.svg";